import { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import Button from "../../componentes/button/button";

function dataUrlParaArquivo(dataUrl, nomeArquivo) {
    const [cabecalho, base64] = dataUrl.split(",");
    const mime = cabecalho.match(/:(.*?);/)[1];
    const binario = atob(base64);
    const bytes = new Uint8Array(binario.length);
    for (let i = 0; i < binario.length; i++) {
        bytes[i] = binario.charCodeAt(i);
    }
    return new File([bytes], nomeArquivo, { type: mime });
}

export default function AssinaturaCanvas({ onSalvar, salvando }) {
    const sigPadRef = useRef(null);
    const [historico, setHistorico] = useState([]);
    const [vazio, setVazio] = useState(true);

    function aoFinalizarTraco() {
        setHistorico(sigPadRef.current.toData());
        setVazio(false);
    }

    function limpar() {
        sigPadRef.current.clear();
        setHistorico([]);
        setVazio(true);
    }

    function desfazer() {
        if (historico.length === 0) return;
        const novoHistorico = historico.slice(0, -1);
        sigPadRef.current.clear();
        sigPadRef.current.fromData(novoHistorico);
        setHistorico(novoHistorico);
        setVazio(novoHistorico.length === 0);
    }

    function salvar() {
        if (sigPadRef.current.isEmpty()) return;
        const dataUrl = sigPadRef.current.getCanvas().toDataURL("image/png");
        const arquivo = dataUrlParaArquivo(dataUrl, "assinatura.png");
        onSalvar(arquivo).then(() => limpar()).catch(() => {});
    }

    return (
        <div className="flex flex-col gap-3">
            <div className="border border-dashed border-border rounded-lg bg-muted/40 overflow-hidden">
                <SignatureCanvas
                    ref={sigPadRef}
                    penColor="black"
                    backgroundColor="rgba(0,0,0,0)"
                    onEnd={aoFinalizarTraco}
                    canvasProps={{ className: "w-full h-48 touch-none" }}
                />
            </div>
            <p className="text-xs text-muted-foreground">Desenhe sua assinatura acima utilizando o mouse ou o dedo (em telas touch).</p>
            <div className="flex justify-end gap-2">
                <Button variant="outline" label="Limpar" iconLeft="fa fa-eraser" onClick={limpar} disabled={vazio || salvando} />
                <Button variant="outline" label="Desfazer" iconLeft="fa fa-undo" onClick={desfazer} disabled={historico.length === 0 || salvando} />
                <Button label="Salvar" iconLeft="fa fa-check" onClick={salvar} loading={salvando} disabled={vazio} />
            </div>
        </div>
    );
}
